import { render } from "./StateBuilding.vue?vue&type=template&id=e5edccfe"
import script from "./StateBuilding.vue?vue&type=script&lang=js"
export * from "./StateBuilding.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__